import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LinkPlayerApiModal from './LinkPlayerApiModal';
import SyncPlayerModal from './SyncPlayerModal';
export default class EditPlayerPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "player", null);
    _defineProperty(this, "teams", []);
    _defineProperty(this, "selectedTeamIds", []);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "loadingTeams", true);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "saving", false);
    // Form state
    _defineProperty(this, "name", '');
    _defineProperty(this, "photoUrl", '');
    _defineProperty(this, "aliases", []);
    _defineProperty(this, "newAliasText", '');
    _defineProperty(this, "isActive", true);
    _defineProperty(this, "number", '');
    _defineProperty(this, "position", '');
    _defineProperty(this, "entityType", 'player');
    _defineProperty(this, "birthDate", '');
    _defineProperty(this, "birthPlace", '');
    _defineProperty(this, "height", '');
    _defineProperty(this, "weight", '');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    this.loadData();
  }
  loadData() {
    this.loading = true;
    this.loadingTeams = true;
    const id = m.route.param('id');
    const loadTeamsPromise = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/teams'
    }).then(response => {
      this.teams = app.store.pushPayload(response);
      this.loadingTeams = false;
    }).catch(err => {
      console.error('Error loading teams:', err);
      this.loadingTeams = false;
    });
    const loadPlayerPromise = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/players"
    }).then(response => {
      app.store.pushPayload(response);
      this.player = app.store.getById('nagusi_players', id);
      if (this.player) {
        this.initForm();
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.alerts.not_found'));
        m.route.set(app.route('bizkaitarra-lineup.taldezaina.players'));
      }
    }).catch(() => {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.alerts.error_load'));
      m.route.set(app.route('bizkaitarra-lineup.taldezaina.players'));
    });
    Promise.all([loadTeamsPromise, loadPlayerPromise]).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  initForm() {
    if (!this.player) return;
    this.name = this.player.name() || '';
    this.photoUrl = this.player.photoUrl() || '';
    this.isActive = typeof this.player.isActive === 'function' ? !!this.player.isActive() : true;
    this.number = this.player.number() !== null && this.player.number() !== undefined ? String(this.player.number()) : '';
    this.position = this.player.position() || '';
    this.entityType = this.player.attribute('entityType') || 'player';
    this.birthDate = this.player.birthDate() || '';
    this.birthPlace = this.player.birthPlace() || '';
    const rawHeight = this.player.height() !== null && this.player.height() !== undefined ? String(this.player.height()) : '';
    this.height = rawHeight.replace(/\D/g, '');
    const rawWeight = this.player.weight() !== null && this.player.weight() !== undefined ? String(this.player.weight()) : '';
    this.weight = rawWeight.replace(/\D/g, '');

    // Parse aliases split by comma
    const aliasesRaw = this.player.attribute('aliases') || '';
    this.aliases = aliasesRaw ? aliasesRaw.split(',').map(s => s.trim()).filter(Boolean) : [];

    // Parse existing team IDs
    const existingTeams = this.player.teams() || [];
    this.selectedTeamIds = existingTeams.map(t => String(t.id()));
  }
  toggleTeam(teamId, checked) {
    const idStr = String(teamId);
    if (checked) {
      if (!this.selectedTeamIds.includes(idStr)) {
        this.selectedTeamIds.push(idStr);
      }
    } else {
      this.selectedTeamIds = this.selectedTeamIds.filter(id => id !== idStr);
    }
    m.redraw();
  }
  addAlias() {
    const alias = this.newAliasText.trim();
    if (alias && !this.aliases.includes(alias)) {
      this.aliases.push(alias);
      this.newAliasText = '';
      m.redraw();
    }
  }
  removeAlias(index) {
    this.aliases.splice(index, 1);
    m.redraw();
  }
  savePlayer(e) {
    e.preventDefault();
    this.saving = true;

    // Ensure we add any text left in the input field as an alias
    this.addAlias();
    const cleanAliases = this.aliases.map(s => s.trim()).filter(Boolean).join(',');
    app.request({
      method: 'PATCH',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/players/".concat(this.player.id()),
      body: {
        data: {
          type: 'nagusi_players',
          id: this.player.id(),
          attributes: {
            name: this.name.trim(),
            photoUrl: this.photoUrl.trim() || null,
            aliases: cleanAliases,
            isActive: this.isActive,
            number: this.entityType !== 'coach' && this.number ? parseInt(this.number, 10) : null,
            position: this.entityType === 'coach' ? null : this.position || null,
            birthDate: this.birthDate || null,
            birthPlace: this.birthPlace.trim() || null,
            height: this.height ? parseInt(this.height, 10) : null,
            weight: this.weight ? parseInt(this.weight, 10) : null
          },
          relationships: {
            teams: {
              data: this.selectedTeamIds.map(id => ({
                type: 'nagusi_teams',
                id
              }))
            }
          }
        }
      }
    }).then(response => {
      if (response) {
        this.player = app.store.pushPayload(response);
      }
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.alerts.success_save'));
      this.initForm();
      m.redraw();
    }).catch(error => {
      console.error('Error saving player:', error);
      this.saving = false;
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.alerts.error_save'));
      m.redraw();
    });
  }
  view() {
    if (!this.canManage) return null;
    if (this.loading) {
      return m("div", {
        className: "EditPlayerPage"
      }, m("div", {
        className: "container",
        style: "padding: 40px; text-align: center;"
      }, m(LoadingIndicator, null)));
    }
    return m("div", {
      className: "EditPlayerPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina.players'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.nav_back_players')), m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-user-shield"
    }), app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.nav_back_taldezaina'))), m("div", {
      className: "EditPlayer-header",
      style: "margin-bottom: 40px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 20px;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 20px;"
    }, this.photoUrl ? m("img", {
      src: this.photoUrl,
      alt: this.player.name(),
      style: "height: 75px; width: 75px; border-radius: 50%; object-fit: cover; border: 3px solid rgba(255, 255, 255, 0.1);"
    }) : m("div", {
      style: "height: 75px; width: 75px; border-radius: 50%; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; border: 3px solid rgba(255, 255, 255, 0.1);"
    }, m("i", {
      className: "fas fa-user",
      style: "font-size: 2.2rem; color: var(--muted-color);"
    })), m("div", null, m("div", {
      style: "display: flex; align-items: center; gap: 10px; flex-wrap: wrap;"
    }, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, this.player.name()), this.entityType !== 'coach' && this.number && m("span", {
      style: "background: rgba(255, 255, 255, 0.1); color: var(--heading-color); border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 6px; padding: 3px 10px; font-size: 0.9em; font-weight: bold;"
    }, "#", this.number), this.entityType !== 'coach' && this.position && m("span", {
      style: "background: rgba(59, 130, 246, 0.15); color: #60a5fa; border: 1px solid rgba(59, 130, 246, 0.3); border-radius: 6px; padding: 3px 10px; font-size: 0.85em; font-weight: bold;"
    }, app.translator.trans("bizkaitarra-lineup.forum.players_mgmt.positions.".concat(this.position.toLowerCase()))), this.entityType === 'coach' && m("span", {
      style: "background: rgba(234, 179, 8, 0.2); color: #facc15; border: 1px solid rgba(234, 179, 8, 0.4); border-radius: 6px; padding: 3px 10px; font-size: 0.85em; font-weight: bold;"
    }, "Entrenador"), !this.isActive && m("span", {
      style: "background: rgba(239, 68, 68, 0.2); color: #f87171; border: 1px solid rgba(239, 68, 68, 0.4); border-radius: 6px; padding: 3px 10px; font-size: 0.85em; font-weight: bold;"
    }, "Inactivo")), m("div", {
      style: "display: flex; align-items: center; gap: 15px; flex-wrap: wrap; margin-top: 6px;"
    }, m("span", {
      style: "font-size: 0.9em; color: var(--muted-color);"
    }, "ID Interno: ", m("code", null, "#", this.player.id())), this.player.apiId() ? m("div", {
      style: "display: inline-flex; align-items: center; gap: 8px;"
    }, m("span", {
      style: "background: rgba(34, 197, 94, 0.15); color: #4ade80; border: 1px solid rgba(34, 197, 94, 0.3); border-radius: 6px; padding: 2px 8px; font-size: 0.8em; font-weight: bold; display: inline-flex; align-items: center; gap: 5px;"
    }, m("i", {
      className: "fas fa-check-circle"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.badge_linked'), " (#", this.player.apiId(), ")"), m(Button, {
      className: "Button Button--link Button--small",
      onclick: () => app.modal.show(LinkPlayerApiModal, {
        player: this.player,
        onLink: () => this.loadData()
      }),
      style: "font-size: 0.8em; padding: 0;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.btn_change_link'))) : m("div", {
      style: "display: inline-flex; align-items: center; gap: 10px;"
    }, m("span", {
      style: "background: rgba(234, 179, 8, 0.15); color: #facc15; border: 1px solid rgba(234, 179, 8, 0.3); border-radius: 6px; padding: 3px 10px; font-size: 0.8em; font-weight: bold; display: inline-flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.badge_unlinked')), m(Button, {
      className: "Button Button--primary Button--small",
      onclick: () => app.modal.show(LinkPlayerApiModal, {
        player: this.player,
        onLink: () => this.loadData()
      }),
      style: "border-radius: 6px; font-size: 0.8em; font-weight: bold; padding: 4px 12px; display: inline-flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-link"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.btn_link')))))), this.player.apiId() && m(Button, {
      className: "Button Button--secondary",
      onclick: () => app.modal.show(SyncPlayerModal, {
        player: this.player,
        onSync: () => this.loadData()
      }),
      style: "border-radius: 8px; font-weight: bold; padding: 10px 18px; display: inline-flex; align-items: center; gap: 8px; border: 1px solid rgba(59, 130, 246, 0.4); background: rgba(59, 130, 246, 0.1); color: #60a5fa;"
    }, m("i", {
      className: "fas fa-sync-alt"
    }), app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.btn_sync'))), m("form", {
      onsubmit: this.savePlayer.bind(this)
    }, m("div", {
      style: "display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 30px; margin-bottom: 30px;"
    }, m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 30px; display: flex; flex-direction: column; gap: 20px; align-items: center;"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; width: 100%; margin: 0 0 10px 0; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 12px; color: var(--heading-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.section_photo')), m("div", {
      style: "position: relative;"
    }, this.photoUrl ? m("img", {
      src: this.photoUrl,
      alt: "Preview",
      style: "height: 160px; width: 160px; border-radius: 50%; object-fit: cover; border: 4px solid var(--primary-color); box-shadow: 0 8px 32px rgba(0,0,0,0.3); transition: border-color 0.3s ease;"
    }) : m("div", {
      style: "height: 160px; width: 160px; border-radius: 50%; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; border: 4px dashed rgba(255,255,255,0.15);"
    }, m("i", {
      className: "fas fa-user-circle",
      style: "font-size: 6rem; color: var(--muted-color);"
    }))), m("div", {
      style: "width: 100%; display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.field_name')), m("input", {
      className: "FormControl",
      type: "text",
      value: this.name,
      oninput: e => this.name = e.target.value,
      required: true,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "width: 100%; display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.field_photo_url')), m("input", {
      className: "FormControl",
      type: "text",
      placeholder: String(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.photo_url_placeholder')),
      value: this.photoUrl,
      oninput: e => this.photoUrl = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), this.entityType !== 'coach' ? m("div", {
      style: "width: 100%; display: grid; grid-template-columns: 1fr 1fr; gap: 15px;"
    }, m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.position')), m("select", {
      className: "FormControl",
      value: this.position,
      onchange: e => this.position = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 8px 12px; height: 42px;"
    }, m("option", {
      value: ""
    }, "-- Sin posici\xF3n --"), m("option", {
      value: "goalkeeper"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.positions.goalkeeper')), m("option", {
      value: "defender"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.positions.defender')), m("option", {
      value: "midfielder"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.positions.midfielder')), m("option", {
      value: "attacker"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.positions.attacker')))), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.number')), m("input", {
      className: "FormControl",
      type: "number",
      placeholder: "p. ej. 10",
      value: this.number,
      oninput: e => this.number = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 8px 12px; height: 42px;"
    }))) : m("div", {
      style: "padding: 10px 14px; background: rgba(234, 179, 8, 0.1); border: 1px solid rgba(234, 179, 8, 0.25); border-radius: 8px; color: #facc15; font-size: 0.9em; display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-info-circle"
    }), m("span", null, "Esta ficha es de tipo ", m("strong", null, "Entrenador"), ", por lo que no aplica demarcaci\xF3n en el campo ni n\xFAmero de dorsal.")), m("div", {
      style: "width: 100%; display: grid; grid-template-columns: 1fr 1fr; gap: 15px;"
    }, m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.birth_date')), m("input", {
      className: "FormControl",
      type: "date",
      value: this.birthDate,
      oninput: e => this.birthDate = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 8px 12px; height: 42px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.birth_place')), m("input", {
      className: "FormControl",
      type: "text",
      placeholder: "p. ej. Bilbao",
      value: this.birthPlace,
      oninput: e => this.birthPlace = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 8px 12px; height: 42px;"
    }))), m("div", {
      style: "width: 100%; display: grid; grid-template-columns: 1fr 1fr; gap: 15px;"
    }, m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.field_height')), m("input", {
      className: "FormControl",
      type: "number",
      placeholder: "p. ej. 182",
      value: this.height,
      oninput: e => this.height = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 8px 12px; height: 42px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.field_weight')), m("input", {
      className: "FormControl",
      type: "number",
      placeholder: "p. ej. 75",
      value: this.weight,
      oninput: e => this.weight = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 8px 12px; height: 42px;"
    }))), m("div", {
      style: "width: 100%; display: flex; flex-direction: column; gap: 8px; margin-top: 10px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--heading-color); font-size: 0.95em;"
    }, "Estado del Jugador"), m("label", {
      style: "display: flex; align-items: center; gap: 12px; cursor: pointer; user-select: none; padding: 12px 16px; border-radius: 12px; background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.1); transition: border-color 0.2s ease;"
    }, m("input", {
      type: "checkbox",
      checked: this.isActive,
      onchange: e => this.isActive = e.target.checked,
      style: "width: 18px; height: 18px; cursor: pointer; accent-color: var(--primary-color);"
    }), m("div", {
      style: "display: flex; flex-direction: column;"
    }, m("span", {
      style: "font-weight: bold; color: ".concat(this.isActive ? '#4caf50' : '#f87171', "; font-size: 0.95em;")
    }, this.isActive ? 'Jugador Activo' : 'Jugador Inactivo'), m("span", {
      style: "font-size: 0.8em; color: var(--muted-color);"
    }, this.isActive ? 'Aparece en sugerencias de alineación' : 'Oculto en desplegables de alineaciones'))))), m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 30px; display: flex; flex-direction: column; gap: 20px;"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 10px 0; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 12px; color: var(--heading-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.section_aliases')), m("p", {
      style: "color: var(--muted-color); font-size: 0.95em; margin: 0 0 10px 0; line-height: 1.4;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.aliases_help')), m("div", {
      style: "display: flex; flex-direction: column; gap: 10px; max-height: 280px; overflow-y: auto; padding-right: 5px;"
    }, this.aliases.map((alias, index) => m("div", {
      key: index,
      style: "display: flex; gap: 10px; align-items: center; background: rgba(255,255,255,0.02); padding: 6px; border-radius: 10px; border: 1px solid rgba(255,255,255,0.04);"
    }, m("input", {
      className: "FormControl",
      value: alias,
      oninput: e => {
        this.aliases[index] = e.target.value;
        m.redraw();
      },
      placeholder: String(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.alias_input_placeholder')),
      style: "flex: 1; border-radius: 8px; border: 1px solid rgba(255,255,255,0.08); background: rgba(0,0,0,0.1); padding: 8px 12px;"
    }), m(Button, {
      className: "Button Button--danger Button--icon",
      icon: "fas fa-trash",
      onclick: () => this.removeAlias(index),
      style: "border-radius: 8px; height: 36px; width: 36px; padding: 0; display: inline-flex; align-items: center; justify-content: center;",
      title: String(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.btn_remove_alias'))
    }))), this.aliases.length === 0 && m("p", {
      style: "color: var(--muted-color); text-align: center; padding: 20px 0; font-style: italic; margin: 0;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.empty_aliases'))), m("div", {
      style: "display: flex; gap: 10px; align-items: center; margin-top: 15px; border-top: 1px dashed rgba(255,255,255,0.08); padding-top: 20px;"
    }, m("input", {
      className: "FormControl",
      placeholder: String(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.new_alias_placeholder')),
      value: this.newAliasText,
      oninput: e => this.newAliasText = e.target.value,
      onkeydown: e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.addAlias();
        }
      },
      style: "flex: 1; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    }), m(Button, {
      type: "button",
      className: "Button Button--primary",
      onclick: () => this.addAlias(),
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; font-weight: bold; height: 38px; padding: 0 16px;"
    }, m("i", {
      className: "fas fa-plus"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.btn_add_alias'))))), m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 30px; display: flex; flex-direction: column; gap: 20px;"
    }, m("div", null, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 6px 0; color: var(--heading-color);"
    }, m("i", {
      className: "fas fa-shield-alt",
      style: "margin-right: 10px; color: var(--primary-color);"
    }), app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.section_teams')), m("p", {
      style: "color: var(--muted-color); font-size: 0.95em; margin: 0; line-height: 1.4;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.teams_help'))), this.loadingTeams ? m("div", {
      style: "padding: 20px; text-align: center;"
    }, m(LoadingIndicator, null)) : m("div", {
      style: "display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 12px; max-height: 320px; overflow-y: auto; padding-right: 5px;"
    }, this.teams.map(team => {
      const teamIdStr = String(team.id());
      const isChecked = this.selectedTeamIds.includes(teamIdStr);
      return m("label", {
        key: team.id(),
        style: "display: flex; align-items: center; gap: 12px; padding: 12px 16px; border-radius: 12px; cursor: pointer; user-select: none; transition: all 0.2s ease; border: 1px solid ".concat(isChecked ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.08)', "; background: ").concat(isChecked ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.02)', ";")
      }, m("input", {
        type: "checkbox",
        checked: isChecked,
        onchange: e => this.toggleTeam(teamIdStr, e.target.checked),
        style: "cursor: pointer; width: 16px; height: 16px; accent-color: var(--primary-color);"
      }), team.logoUrl() ? m("img", {
        src: team.logoUrl(),
        alt: team.name(),
        style: "height: 24px; width: 24px; object-fit: contain;"
      }) : m("i", {
        className: "fas fa-shield-alt",
        style: "font-size: 1.2rem; color: var(--muted-color);"
      }), m("span", {
        style: "font-size: 0.95em; font-weight: ".concat(isChecked ? 'bold' : 'normal', "; color: var(--heading-color); flex: 1;")
      }, team.name()));
    }))), m("div", {
      style: "margin-top: 40px; display: flex; justify-content: flex-end; gap: 15px; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 25px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina.players'),
      className: "Button",
      style: "border-radius: 8px; padding: 10px 20px; font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.btn_cancel')), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.saving,
      style: "border-radius: 8px; padding: 10px 24px; font-weight: bold; display: inline-flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-save"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.edit_player.btn_save'))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/EditPlayerPage', EditPlayerPage);